import { useTranslation } from 'react-i18next'

import { FileUploadProps } from '@ui/components/FileUpload/FileUpload'

import { DocumentFileUpload } from './DocumentFileUpload'
import { FileData } from './types'

import styles from './FileUpload.module.scss'

type DoubleSidedProps = Omit<FileUploadProps, 'files' | 'onUpload'> & {
  files?: FileData[]
  onUpload: (files: FileData[]) => void
}
export const DoubleSidedDocumentFileUploads: React.FC<DoubleSidedProps> = (props) => {
  const { files = [], onUpload, ...rest } = props
  const { t } = useTranslation()

  const frontFile = files[0]
  const backFile = files[1]

  const handleFrontChange = (newFiles: FileData[]) => {
    const updated = [newFiles[0], backFile].filter(Boolean) as FileData[]
    onUpload(updated)
  }

  const handleBackChange = (newFiles: FileData[]) => {
    const updated = [frontFile, newFiles[0]].filter(Boolean) as FileData[]
    onUpload(updated)
  }

  return (
    <div className={styles.doubleSidedWrapper}>
      <DocumentFileUpload
        {...rest}
        title={t('Document front side')}
        file={frontFile}
        maxFiles={1}
        multiple={false}
        onUpload={(f) => handleFrontChange([f])}
      />

      <DocumentFileUpload
        {...rest}
        title={t('Document back side')}
        file={backFile}
        maxFiles={1}
        multiple={false}
        onUpload={(f) => handleBackChange([f])}
      />
    </div>
  )
}
